declare global {
  interface Window {
    dataLayer: IArguments[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_MEASUREMENT_ID = 'G-TTPKJHB0E0';

/**
 * Google Analytics only runs against the production build. Local dev, the dev
 * pipeline and E2E runs stay out of the property entirely.
 */
export const isAnalyticsEnabled = (): boolean => import.meta.env.VITE_APP_ENV === 'production';

/**
 * Injects the gtag.js snippet. Safe to call more than once — subsequent calls
 * are a no-op (StrictMode mounts the tree twice in development).
 */
export const initAnalytics = (): void => {
  if (!isAnalyticsEnabled() || window.gtag) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // gtag.js reads the raw `arguments` object off dataLayer, so it cannot be
    // spread into an array here.
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);
};
